module.exports = __webpack_public_path__ + "static/media/lease2_img1.bfb8d158.jpg";